import { useContext } from 'react';
import { ThemeMode, TUseDarkMode } from 'templates/layout/ThemeTypeProvider';

const useDarkMode = (): TUseDarkMode => useContext(ThemeMode);

export default useDarkMode;
